

export class VehicleCompanyStatusInput implements IVehicleCompanyStatusInput {
    /** The auto-generated id of the vehicle company master */
    vehicleCompanyId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IVehicleCompanyStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleCompanyId = _data["vehicleCompanyId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleCompanyStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleCompanyStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleCompanyId"] = this.vehicleCompanyId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleCompanyStatusInput {
    /** The auto-generated id of the vehicle company master */
    vehicleCompanyId: number;
    /** The updated status */
    status: number;
}

